import { Typography } from "@material-ui/core"
import styled from "styled-components"

type GiftCardStaticTextProps = {
  amount: number | string
  quantity: number
}

const GiftCardStaticText = ({
  amount = 0,
  quantity = 1,
}: GiftCardStaticTextProps) => {
  const StyledText = styled(Typography).attrs({ variant: "body1" })`
    text-align: right;
    line-height: 26px;
    span {
      font-weight: bold;
      font-family: NarkisBlock;
    }
    ${(p) => p.theme.breakpoints.up("md")} {
      width: 680px;
    }
  `

  return (
    <StyledText>
      בחרו באופציה הזאת אם תרצו לשלוח{" "}
      {quantity <= 1 ? "גיפטקארד" : "גיפטקארדים"} בסכום של
      <span>
        {" "}
        {parseInt(amount.toString().replace(/[₪]/g, "")) * quantity
          ? parseInt(amount.toString().replace(/[₪]/g, "")) * quantity
          : 0}{" "}
        {`ש"ח`}
      </span>{" "}
      כל תקופת זמן קבועה. החיוב הראשון יבוצע בתאריך הראשון שתבחרו ובהתאם לתדירות
      הנבחרת.
    </StyledText>
  )
}

export default GiftCardStaticText
